/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { Klass, LexicalNode } from 'lexical';

import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { HashtagNode } from '@lexical/hashtag';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { MarkNode } from '@lexical/mark';
import { OverflowNode } from '@lexical/overflow';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { AutocompleteNode } from './AutocompleteNode';
import { ImageNode } from './ImageNode';
import { YouTubeNode } from './YouTubeNode';
import { EmbedCodeNode } from '@/components/LexicalEditor/nodes/EmbedCodeNode';
import { CollapsibleContentNode } from '@/components/LexicalEditor/plugins/CollapsiblePlugin/CollapsibleContentNode';
import { CollapsibleTitleNode } from '@/components/LexicalEditor/plugins/CollapsiblePlugin/CollapsibleTitleNode';
import { CollapsibleContainerNode } from '@/components/LexicalEditor/plugins/CollapsiblePlugin/CollapsibleContainerNode';

const PlaygroundNodes: Array<Klass<LexicalNode>> = [
  HeadingNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  CodeNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  HashtagNode,
  CodeHighlightNode,
  AutoLinkNode,
  LinkNode,
  OverflowNode,
  ImageNode,
  AutocompleteNode,
  HorizontalRuleNode,
  YouTubeNode,
  EmbedCodeNode,
  MarkNode,
  CollapsibleContainerNode,
  CollapsibleContentNode,
  CollapsibleTitleNode,
];

export default PlaygroundNodes;
